import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { compose } from 'recompose'
import Dialog from 'react-toolbox/lib/dialog'
import T from 'i18n-react'
import CSSModules from 'helpers/CSSModulesUtil'

import Dropdown from './Dropdown'

import {
  APPROVE_TYPE,
  MODULE_NAME,
} from './constants'

import styles from './styles.scss'

class AcceptDialog extends Component {
  onCancel = () => this.props.disableDialog()
  onSubmit = () => this.props.onSubmit()

  actions = [
    { label: 'Cancel', onClick: this.onCancel },
    { label: 'Submit', onClick: this.onSubmit },
  ]

  source = () => {
    return Object.values(APPROVE_TYPE)
      .filter((type) => {
        return (
          (type === APPROVE_TYPE.SKIP_TO_KICKOFF && this.props.skipables.skipableToKickoff) ||
          (type === APPROVE_TYPE.SKIP_TO_DESIGN_REVIEW && this.props.skipables.skipableToDesignReview) ||
          (type === APPROVE_TYPE.SKIP_TO_QUALIFICATION && this.props.skipables.skipableToQualification) ||
          (type === APPROVE_TYPE.SUBMIT)
        )
      })
      .map(({label, value}) => ({
        value,
        label: T.translate(label)
      }))
  }

  render() {
    const {
      active,
      type,
      onUpdateType,
      disableDialog
    } = this.props

    return (
      <Dialog
        actions={this.actions}
        active={active}
        title={T.translate('containers.approval.approvalDialog.acceptDialog.title')}
        onOverlayClick={disableDialog}
        onEscKeyDown={disableDialog}
        type='small'
      >
        <Dropdown
          source={this.source()}
          value={type}
          onChange={onUpdateType}
        />
      </Dialog>
    )
  }
}

const withStyle = CSSModules(styles)
export default compose(
  withStyle
)(AcceptDialog)
